<template>
    <div class="about-box">
        <div class="about-box-con">
            <h3>關於我們</h3>
            <div v-html="content"></div>
            <!-- <div class="about-box-con-img">
                <img src="@p/assets/images/lesson.png" alt="">
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            content:''
        }
    },
    created(){
        this.getAbout()
    },
    methods:{
        async getAbout(){
            await this.$http.message.getAboutus().then(res=>{
                if(res.status === 200){
                    this.content = res.data.data.content;
                }
            }).catch(v=>{})
        },
    },
}
</script>
<style lang="less" scoped>
    .about-box{
        padding-bottom: 20px;
        &-con{
            min-height: 643px;
            background:rgba(241,241,246,1);
            margin-top: 16px;
            display: flex;
            // align-items: center;
            flex-flow: column;
            padding: 0 60px;
            padding-bottom: 20px;
            box-sizing: border-box;
            &-img{
                width: 676px;
                height: 334px;
                margin-top: 24px;
                text-align: center;
                img{
                    height: 100%;
                    max-width: 100%;
                    max-height: 100%;
                }
            }
            h3{
                margin-top: 26px;
                margin-bottom: 16px;
                color:rgba(51,51,51,1);
            }
            p{
                margin-top: 8px;
                // text-indent:2em;
                color:rgba(51,51,51,0.70);
                font-size:14px;
                line-height:24px;
            }
        }
    }
</style>
